import { IndustryConversionForm } from "./Main";

export const Register = () => {
  return <IndustryConversionForm />;
};
